import { useEffect } from 'react';

const ClarityAnalytics = ({ projectId }) => {
  useEffect(() => {
    if (import.meta.env.VITE_APP_ENV === 'production') {
      const clarityScript = document.createElement('script');
      clarityScript.type = 'text/javascript';
      clarityScript.innerHTML = `
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${projectId}");
      `;

      document.head.appendChild(clarityScript);
    }

    return () => {
      if (import.meta.env.VITE_APP_ENV === 'production') {
        const scripts = document.head.querySelectorAll(
          `script[src*="clarity.ms"]`,
        );
        scripts.forEach(script => script.remove());
      }
    };
  }, [projectId]);

  return null;
};

export default ClarityAnalytics;
